import React, { useState } from "react";

function Registration() {
  const [OwnerName, setOwnerName] = useState("");
  const [OwnerPhone, setOwnerPhone] = useState("");

  // const sendDataToAPI = () => {
  //   axios.post(`https://62e74e8269bd03090f7b19cb.mockapi.io/MsUmkm`, {
  //     OwnerName,
  //     OwnerPhone,
  //   });
  //   console.log("Data is Created!");
  // };

  /*Untuk melihat apakah data terekam */
  console.log(OwnerName);
  console.log(OwnerPhone);

  return (
    <div className="daftar-background">
      <div className="daftar-container">
        <form className="daftar-form">
          <p className="daftar-title">Identitas Diri</p>
          <div className="form-registration">
            <label>Nama*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              onChange={(e) => setOwnerName(e.target.value)}
              placeholder="Enter full name"
            />
          </div>

          <div className="form-registration">
            <label>Tanggal Lahir*</label>
            <input type="date" required="required" className="form-control" />
          </div>

          <div className="form-registration">
            <label>No. Telp*</label>
            <input
              type="number"
              required="required"
              className="form-control"
              onChange={(e) => setOwnerPhone(e.target.value)}
              placeholder="Enter phone number"
            />
          </div>

          <div className="form-registration">
            <label>Email*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter email"
            />
          </div>

          <div className="form-registration">
            <label>Password*</label>
            <input
              type="password"
              required="required"
              className="form-control"
              placeholder="Enter password"
            />
          </div>

          <div className="form-registration">
            <label>Konfirmasi Password*</label>
            <input
              type="password"
              required="required"
              className="form-control"
              placeholder="Konfirmasi password"
            />
          </div>

          <div className="form-registration">
            <label>Alamat*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter Alamat.."
            />
          </div>

          <div className="form-registration">
            <label>Kelurahan*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter kelurahan"
            />
          </div>

          <div className="form-registration">
            <label>Kecamatan*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter kecamatan"
            />
          </div>

          <div className="form-registration">
            <label>Kota/Kabupaten*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter kota/kabupaten"
            />
          </div>

          <div className="form-registration">
            <label>Provinsi*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter provinsi"
            />
          </div>

          <div className="form-registration">
            <label>Kode Pos*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter kode pos"
            />
          </div>

          <div className="form-registration">
            <div className="labelBox">
              <label>Foto Anda*</label>
            </div>

            <div className="daftar-userPhoto">
              <img
                className="daftar-uploadedImage"
                src="http://via.placeholder.com/300"
                alt=""
              />
              <button className="uploadImageButton">Tambah Foto</button>
            </div>
          </div>

          <hr></hr>

          <p className="daftar-title">Identitas UMKM</p>
          <div className="form-registration">
            <label>Nama UMKM*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter nama umkm"
            />
          </div>

          <div className="form-registration">
            <label>Email Usaha*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter email"
            />
          </div>

          <div className="form-registration">
            <label>Alamat Usaha*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter Alamat Usaha.."
            />
          </div>

          <div className="form-registration">
            <label>Kelurahan*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter kelurahan"
            />
          </div>

          <div className="form-registration">
            <label>Kecamatan*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter kecamatan"
            />
          </div>

          <div className="form-registration">
            <label>Kota/Kabupaten*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter kota/kabupaten"
            />
          </div>

          <div className="form-registration">
            <label>Provinsi*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter provinsi"
            />
          </div>

          <div className="form-registration">
            <label>Kode Pos*</label>
            <input
              type="text"
              required="required"
              className="form-control"
              placeholder="Enter kode pos"
            />
          </div>

          <div className="form-registration">
            <div className="labelBox">
              <label>Link Sosmed*</label>
            </div>

            <div className="inputBox">
              <input
                type="text"
                required="required"
                className="form-control"
                placeholder="Enter link UMKM.."
              />
              <input
                type="text"
                className="form-control"
                placeholder="Enter link UMKM.."
              />
            </div>
          </div>

          <div className="form-registration">
            <label>Kategori</label>
            <select name="" id="">
              <option value="pakaian">Pakaian</option>
              <option value="kecantikan">Kecantikan</option>
              <option value="mainan">Mainan</option>
              <option value="perabotan">Perabotan</option>
              <option value="elektronik">Elektronik</option>
              <option value="makanan">Makanan</option>
              <option value="aksesoris">Aksesoris</option>
              <option value="herbal">Herbal</option>
              <option value="olahraga">Olahraga</option>
            </select>
          </div>

          <div className="form-registration">
            <div className="labelBox">
              <label>Logo UMKM*</label>
            </div>

            <div className="daftar-logoUMKM">
              <img
                className="daftar-uploadedImage"
                src="http://via.placeholder.com/200"
                alt=""
              />
              <button className="uploadImageButton">Tambah Logo</button>
            </div>
          </div>

          <div className="registration-uploadProduct">
            <div className="labelBox">
              <label>Upload Produk*</label>
            </div>

            <div className="inputBox">
              <div className="uploadImage">
                <img
                  className="daftar-uploadedImage"
                  src="http://via.placeholder.com/200"
                  alt=""
                />
                <button className="uploadImageButton">Tambah Foto</button>
                <input
                  type="text"
                  name="katalogName"
                  id=""
                  placeholder="Masukkan Nama Produk.."
                />
              </div>

              <div className="uploadImage">
                <img
                  className="daftar-uploadedImage"
                  src="http://via.placeholder.com/200"
                  alt=""
                />
                <button className="uploadImageButton">Tambah Foto</button>
                <input
                  type="text"
                  name="katalogName"
                  id=""
                  placeholder="Masukkan Nama Produk.."
                />
              </div>

              <div className="uploadImage">
                <img
                  className="daftar-uploadedImage"
                  src="http://via.placeholder.com/200"
                  alt=""
                />
                <button className="uploadImageButton">Tambah Foto</button>
                <input
                  type="text"
                  name="katalogName"
                  id=""
                  placeholder="Masukkan Nama Produk.."
                />
              </div>

              <div className="uploadImage">
                <img
                  className="daftar-uploadedImage"
                  src="http://via.placeholder.com/200"
                  alt=""
                />
                <button className="uploadImageButton">Tambah Foto</button>
                <input
                  type="text"
                  name="katalogName"
                  id=""
                  placeholder="Masukkan Nama Produk.."
                />
              </div>

              <div className="uploadImage">
                <img
                  className="daftar-uploadedImage"
                  src="http://via.placeholder.com/200"
                  alt=""
                />
                <button className="uploadImageButton">Tambah Foto</button>
                <input
                  type="text"
                  name="katalogName"
                  id=""
                  placeholder="Masukkan Nama Produk.."
                />
              </div>
            </div>
          </div>

          <button
            className="daftarButton"
            type="button"
            // onClick={sendDataToAPI}
          >
            Daftar
          </button>
        </form>
      </div>
    </div>
  );
}

export default Registration;
